import * as fromDatatype from '../datatype-library/index';

export interface app_filter_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  app_version: fromDatatype.VarcharDatatypeInterface;
  mod_id: fromDatatype.VarcharDatatypeInterface;
  filter_code: fromDatatype.VarcharDatatypeInterface;
  filter_desc: fromDatatype.VarcharDatatypeInterface;
  filter_query: fromDatatype.VarcharDatatypeInterface;
  filter_procedure: fromDatatype.VarcharDatatypeInterface;
  filter_ref_table: fromDatatype.VarcharDatatypeInterface;
  filter_ref_column: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_filter_hdr_RowClass implements app_filter_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  app_version: fromDatatype.VarcharDatatypeInterface;
  mod_id: fromDatatype.VarcharDatatypeInterface;
  filter_code: fromDatatype.VarcharDatatypeInterface;
  filter_desc: fromDatatype.VarcharDatatypeInterface;
  filter_query: fromDatatype.VarcharDatatypeInterface;
  filter_procedure: fromDatatype.VarcharDatatypeInterface;
  filter_ref_table: fromDatatype.VarcharDatatypeInterface;
  filter_ref_column: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


